import { z } from 'zod';
import { documentsAuthenticitySchema, documentsInstanceStatusSchema, documentsSha256Schema, } from './documents-instance.contract.js';
import { documentsEstimatingAcceptanceBindingSchema } from './documents-estimating-acceptance-envelope.contract.js';
export const documentsPortalEnvelopeCapability = 'documents.portal-envelope.v1';
export const documentsPortalEnvelopeScopeProviderId = 'documents.server.portal-envelope-scope';
export const documentsPortalEnvelopeResourceType = 'documents.document-instance';
export const documentsPortalEnvelopeReadGrant = 'documents.portal-envelopes.read';
export const documentsPortalEnvelopeActionGrant = 'documents.portal-envelopes.action';
export const documentsPortalEnvelopeSchema = z.strictObject({
    id: z.string().uuid(),
    publicId: z.string().uuid(),
    status: documentsInstanceStatusSchema,
    revision: z.number().int().positive(),
    title: z.string().trim().min(1).max(180),
    renderedHtml: z.string().trim().min(1).max(1_000_000),
    renderedHtmlSha256: documentsSha256Schema,
    requiresSignature: z.boolean(),
    consentText: z.string().trim().min(1).max(4_000).nullable(),
    expiresAt: z.string().datetime({ offset: true }),
    firstViewedAt: z.string().datetime({ offset: true }).nullable(),
    signedAt: z.string().datetime({ offset: true }).nullable(),
    declinedAt: z.string().datetime({ offset: true }).nullable(),
    authenticity: documentsAuthenticitySchema,
    signedCopy: z.strictObject({
        available: z.boolean(),
        sha256: documentsSha256Schema.nullable(),
    }),
    estimatingAcceptance: documentsEstimatingAcceptanceBindingSchema.nullable(),
});
export const documentsPortalEnvelopeResponseSchema = z.strictObject({
    contractVersion: z.literal(documentsPortalEnvelopeCapability),
    data: z.array(documentsPortalEnvelopeSchema).max(100),
});
const documentsPortalEnvelopeCommandBaseSchema = z.strictObject({
    commandId: z.string().uuid(),
    instanceId: z.string().uuid(),
    expectedRevision: z.number().int().positive(),
});
export const documentsPortalEnvelopeViewCommandSchema = documentsPortalEnvelopeCommandBaseSchema.extend({ kind: z.literal('view') });
export const documentsPortalEnvelopeDeclineCommandSchema = documentsPortalEnvelopeCommandBaseSchema.extend({ kind: z.literal('decline') });
export const documentsPortalEnvelopeSignCommandSchema = documentsPortalEnvelopeCommandBaseSchema.extend({
    kind: z.literal('sign'),
    typedName: z.string().trim().min(1).max(240),
    consentAccepted: z.literal(true),
});
export const documentsPortalEnvelopeCommandSchema = z.discriminatedUnion('kind', [
    documentsPortalEnvelopeViewCommandSchema,
    documentsPortalEnvelopeDeclineCommandSchema,
    documentsPortalEnvelopeSignCommandSchema,
]);
export const documentsPortalEnvelopeCommandResponseSchema = z.strictObject({
    envelope: documentsPortalEnvelopeSchema,
    command: z.strictObject({ commandId: z.string().uuid(), idempotent: z.boolean() }),
});
//# sourceMappingURL=documents-portal-envelope.contract.js.map